<template>
<div id="partner-apps">
  <h2>Partner Apps</h2>

  <partner-app-nav
    :partnerId="partnerId"
  ></partner-app-nav>

  <pagination
    :resourceUrl="this.apiUrl('/partners/' + this.partnerId + '/partner_apps', true)"
    orderBy="name"
  >
    <template
      slot="paged_item"
      slot-scope="item"
    >
      <router-link
        :class="$root.listItemClasses"
        :to="{ name: 'partner_app', params: { partnerAppId: item.id }}"
      >
        {{ item.name }}
      </router-link>
    </template>
  </pagination>
</div>
</template>

<script>
import Pagination from 'sai-vue-kaminari'

import PartnerAppNav from '@/components/PartnerAppNav'

import PartnerAppsStore from '@/stores/PartnerAppsStore'

export default {
  data () {
    return PartnerAppsStore.state
  },

  components: {
    'pagination': Pagination,
    'partner-app-nav': PartnerAppNav
  },

  props: ['partnerId'],

  created () {

  },

  methods: {
    onPageSuccess (resp) {
      this.partner_apps = this.processSuccess(resp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PartnerApps.vue